import { RateLimitUnit } from 'modules/workflows/constants';

// Form state
export const RADIO_VAL = 'radioVal';
export const CHECKBOX_VAL = 'checkboxVal';

// Node data fields
export const AUTH_TOKEN_FIELD = 'authTokenDisplay';
export const ENDPOINT_FIELD = 'endpoint';
export const PERIOD_FIELD = 'period';
export const PERMIT_FIELD = 'permit';
export const RESOURCE_FIELD = 'resource';
export const WEBHOOK_FIELD = 'workflowWebhookId';
export const EXISTING_AUTH_TOKEN = 'authToken';

export const NODE_DATA_FIELDS = [
  AUTH_TOKEN_FIELD,
  ENDPOINT_FIELD,
  PERIOD_FIELD,
  PERMIT_FIELD,
  RESOURCE_FIELD,
  WEBHOOK_FIELD,
];

export const DEFAULT_RATE_LIMIT_PER_MINUTE = 1000;
const MIN_RATE_LIMIT_PER_MINUTE = 120;
const MIN_RATE_LIMIT_PER_SECOND = MIN_RATE_LIMIT_PER_MINUTE / 60; // minutes / 60 = seconds
export const MIN_RATE_LIMITS = {
  [RateLimitUnit.Minute]: MIN_RATE_LIMIT_PER_MINUTE,
  [RateLimitUnit.Second]: MIN_RATE_LIMIT_PER_SECOND,
};

export const VALIDATION_MESSAGES = {
  CLONE: 'Cloning error',
  [ENDPOINT_FIELD]: 'Please enter a valid URL.',
  [PERMIT_FIELD]: 'Must be at least',
};
